import { Film, Image as ImageIcon, Trash2 } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

const fmt = (iso) => new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export const HistoryList = ({ items, activeId, onOpen, onDelete }) => (
  <div data-testid="history-section">
    <div className="flex items-baseline justify-between border-b border-[var(--rf-ink)] pb-3">
      <h2 className="text-lg font-bold tracking-tight">Storico</h2>
      <span className="rf-mono text-[10px] tracking-[0.2em] uppercase text-[var(--rf-grey)]" data-testid="history-count">{items.length} analisi</span>
    </div>
    {items.length === 0 ? (
      <p className="py-6 text-sm text-[var(--rf-grey)]" data-testid="history-empty">Le tue analisi compariranno qui.</p>
    ) : (
      <ul data-testid="history-items-list">
        {items.map((it) => (
          <li key={it.id} className={`group flex items-center gap-4 py-4 border-b rf-line transition-colors ${activeId === it.id ? "bg-[var(--rf-soft)]" : "hover:bg-[var(--rf-soft)]"}`} data-testid={`history-item-${it.id}`}>
            <button onClick={() => onOpen(it.id)} className="flex-1 min-w-0 flex items-center gap-4 text-left pl-2" data-testid={`history-reopen-button-${it.id}`}>
              {it.media_type === "video" ? <Film size={16} strokeWidth={1.5} /> : <ImageIcon size={16} strokeWidth={1.5} />}
              <span className="min-w-0">
                <span className="block text-sm font-semibold truncate">{it.filename}</span>
                <span className="block rf-mono text-[10px] tracking-wider text-[var(--rf-grey)] truncate">
                  {fmt(it.created_at)} · {it.status === "done" ? (it.prompt || "").slice(0, 60) : it.status === "error" ? "errore" : "in attesa"}
                </span>
              </span>
            </button>
            <AlertDialog>
              <AlertDialogTrigger asChild>
                <button className="p-2 mr-1 text-[var(--rf-grey)] hover:text-[var(--rf-red)]" aria-label="Elimina" data-testid={`history-delete-button-${it.id}`}>
                  <Trash2 size={15} />
                </button>
              </AlertDialogTrigger>
              <AlertDialogContent className="rounded-none">
                <AlertDialogHeader>
                  <AlertDialogTitle>Eliminare questa analisi?</AlertDialogTitle>
                  <AlertDialogDescription>L'analisi e il file non saranno più visibili nel tuo storico.</AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                  <AlertDialogCancel className="rounded-none" data-testid="history-delete-cancel">Annulla</AlertDialogCancel>
                  <AlertDialogAction className="rounded-none bg-[var(--rf-red)] hover:bg-black" onClick={() => onDelete(it.id)} data-testid="history-delete-confirm">Elimina</AlertDialogAction>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialog>
          </li>
        ))}
      </ul>
    )}
  </div>
);
